<template>
    <g class="sankey-node">
        <g class="node" @mouseenter="detailHovered(data)" @click="detailClicked(data)" v-tippy="{html: '#popup', followCursor: true, arrow: true, animation: 'fade'}">
            <title>{{data.data.name}}</title>
            <rect :x="x('label')" :y="0" :width="data.children ? x.bandwidth() : width" :height="height" :fill="color(data.depth)" ></rect>
            <foreignObject :x="x('label')" :y="0" :width="data.children ? x.bandwidth() : width" :height="height">
                <body>
                <div class="content">
                    <div class="text" v-if="height > 100">
                        <div class="amount">{{data.data.name}}</div>
                        <div class="percentage">{{numeral(data.value/total).format('0.00%')}}</div>
                    </div>
                </div>
                </body>
            </foreignObject>
        </g>
        <g v-for="(d,key) in data.children" :transform="'translate(0,'+((key * innerPadding) + y(d.accumulate))+')'">
            <title>{{d.data.name}}</title>
            <!--
            <rect :width="x.bandwidth()" :height="y(d.value)" :fill="color(data.depth)" fill-opacity="0.9"></rect>
            -->
            <g :transform="'translate('+x('division')+',0)'">
                <polygon :points="points(d, key)" :fill="color(data.depth)" fill-opacity="0.9"></polygon>
            </g>
            <g :transform="'translate('+parentXAxis.step()+',0)'">
                <sankey-node :data="d" :width="width" :height="y(d.value)" :color="color" :parent-x-axis="parentXAxis" @detail-hovered="detailHovered" @detail-clicked="detailClicked"></sankey-node>
            </g>
        </g>
    </g>
</template>
<style lang="scss">
    .sankey-node{
        .node{
            cursor: pointer;
            foreignObject{
                body{
                    background: none;
                    .content{
                        padding: 10px;
                        color: white;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
<script>
    import * as d3 from 'd3';
    import _ from 'lodash';
    import numeral from 'numeral';

    export default {
        name: 'sankey-node',
        data: function(){
            return {
                innerPadding: 0.01 * this.height,
                xDomain: ['label','division']
            }
        },
        props: {
            width: {default: 1110},
            height: {default: 818},
            data: {},
            dimensions: {},
            color: {},
            parentXAxis: {}
        },
        watch:{
            data: {
                immediate: true,
                handler: function(data){
                    if(!data.children)
                        return;

                    let sum = 0;
                    data.children.forEach(d => {
                        d.accumulate = sum;
                        sum += d.value;
                    })
                }
            }
        },
        methods:{
            numeral: numeral,
            detailHovered: function(n){
                this.$emit('detail-hovered', n)
            },
            detailClicked: function(n){
                this.$emit('detail-clicked', n)
            },
            points: function(d, key){
                let points = [];


                if(key === 0){
                    points.push([0,0]);

                }else{
                    points.push([0,0 - (this.innerPadding / 2)]);
                    points.push([this.x.bandwidth() / 2, 0]);
                }

                points.push([this.x.bandwidth(), 0]);
                points.push([this.x.bandwidth(), this.y(d.value)]);

                if(key === (this.data.children.length - 1)){
                    points.push([0, this.y(d.value)]);

                }else{
                    points.push([this.x.bandwidth() / 2, this.y(d.value)]);
                    points.push([0, this.y(d.value) + (this.innerPadding / 2)]);
                }




                return points.map(d => {
                    return d.join(',');
                }).join(' ');
            }
        },
        computed:{
            x: function(){
                return d3.scaleBand()
                    .paddingInner(0.01)
                    .range([0, this.width])
                    .domain(this.xDomain)
                    .round(true)
            },
            y: function(){
                return d3.scaleLinear()
                    .range([0, this.height - (this.innerPadding * (this.data.children.length - 1))])
                    .domain([0, d3.sum(this.data.children, d => {return d.value})])
            },
            total: function(){
                let node = this.data;
                while(true){
                    if(node.parent)
                        node = node.parent;
                    else{
                        return node.value;
                    }
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/SankeyNode.vue